import { ConstraintFacilityInitialBuildDetailBase } from './base/constraint-facility-initial-build-detail-base';

export class ConstraintFacilityInitialBuildDetail extends ConstraintFacilityInitialBuildDetailBase { }